import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video-icon-1",
  "use": "icon-video-icon-1-usage",
  "viewBox": "0 0 153 498",
  "content": "<symbol viewBox=\"0 0 153 498\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-video-icon-1\">\n<path d=\"M1 491.333H0V492.333H1V491.333ZM153 491.333L143 485.56V497.107L153 491.333ZM0 0.666748V491.333H2V0.666748H0ZM1 492.333H144V490.333H1V492.333Z\" fill=\"#A7F900\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol